import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { ModuleWithProviders, NgModule } from '@angular/core';
import {
  CORRELATION_ID_KEY,
  CorrelationIdPartialState,
  correlationIdReducer,
  RestartJourneyEffects,
} from '@common/data-access-shared';
import {
  AppProvidersConfig,
  AppProvidersConfigToken,
  CommonFeatureCoreModule,
  META_REDUCERS,
} from '@common/feature-core';
import { CommonUiSalesComponentsModule } from '@common/ui-sales-components';
import { BuildConfigService, ENVIRONMENT } from '@common/util-foundation';
import { SharedUiBaseComponentsModule } from '@domgen/dgx-fe-base-components';
import { EffectsModule } from '@ngrx/effects';
import { ActionReducerMap, StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { environment } from '@ao/util-environment';
import { SharedDataAccessNavigationModule } from '@shared/data-access-navigation';
import {
  refreshApiConfigToken,
  SharedFeatureAuthModule,
} from '@shared/feature-auth';

import { AoAppComponent } from './components/ao-app.component';
import { NAVIGATION_RULES } from './modules/navigation-rules.config';
import { AoFeatureShellRoutingModule } from './ao-feature-shell-router.module';
import {
  HeaderModule,
  SharedAoComponentsModule,
} from '@domgen/dgx-ui-whitelabel-components';

const modules = [
  AoFeatureShellRoutingModule,
  CommonUiSalesComponentsModule,
  HttpClientModule,
  SharedUiBaseComponentsModule,
  HeaderModule,
];

@NgModule({
  declarations: [AoAppComponent],
  imports: [
    ...modules,
    CommonModule,
    StoreModule.forRoot(
      {
        [CORRELATION_ID_KEY]: correlationIdReducer,
      } as ActionReducerMap<
        CorrelationIdPartialState & Record<string, unknown>
      >,
      {
        metaReducers: !environment.production
          ? [...META_REDUCERS]
          : [...META_REDUCERS],
        runtimeChecks: {
          strictActionImmutability: true,
          strictStateImmutability: true,
        },
      }
    ),
    SharedDataAccessNavigationModule.forRoot({
      defaultRedirectUrl: environment.applianceDetailsPage,
      navigationRules: [...NAVIGATION_RULES],
    }),
    !environment.production ? StoreDevtoolsModule.instrument() : [],
    CommonFeatureCoreModule,
    EffectsModule.forRoot([RestartJourneyEffects]),
    SharedFeatureAuthModule,
    SharedAoComponentsModule,
  ],
  providers: [
    {
      provide: ENVIRONMENT,
      useValue: environment,
    },
    {
      provide: refreshApiConfigToken,
      useFactory: (buildConfigService: BuildConfigService) =>
        buildConfigService.config.refreshAPI,
      deps: [BuildConfigService],
    },
  ],
  exports: [...modules, AoAppComponent],
})
export class AoFeatureShellModule {
  static forRoot(
    navigationConfig: AppProvidersConfig
  ): ModuleWithProviders<AoFeatureShellModule> {
    return {
      ngModule: AoFeatureShellModule,
      providers: [
        { provide: AppProvidersConfigToken, useValue: navigationConfig },
      ],
    };
  }
}
